import React, {useEffect, useState} from 'react';
import Promise from "bluebird";
import _ from "lodash";
import {appConfig} from "../../firebase/client-app";

const UrlOpener = () => {
    const [urls, setUrls] = useState('');
    const [count, setCount] = useState(1);
    const [initialStep, setInitialStep] = useState(true);

    const handleUrlsChange = event => {
        setUrls(event.target.value);
    };

    const handleCountChange = event => {
        setCount(parseInt(event.target.value));
    };

    const init = () => {
        const urlOpenerInputs = localStorage.getItem(appConfig?.appKey + ".urlOpenerInputs");
        if (urlOpenerInputs) {
            const parsedUrlOpenerInputs = JSON.parse(urlOpenerInputs);
            setUrls(parsedUrlOpenerInputs.urls);
            setCount(parsedUrlOpenerInputs.count);
        }
    }

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            init();
        }
    }, [initialStep]);

    useEffect(() => {
        const urlOpenerInputs = {
            urls,
            count,
        }

        localStorage.setItem(appConfig?.appKey + ".urlOpenerInputs", JSON.stringify(urlOpenerInputs));
    }, [count, urls]);

    const openUrls = async () => {
        const urlArray = urls.split('\n');

        let allUrls = [];
        _.forEach(urlArray, (url) => {
            allUrls = _.concat(allUrls, _.fill(Array(count), url.trim()));
        });

        allUrls = _.compact(allUrls);
        console.log('Opening Urls', allUrls);

        await Promise.mapSeries(allUrls, async (url) => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    window.open(url, '_blank');
                    resolve();
                }, 10);
            });
        });

    };

    return (
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2" htmlFor="urls">
                    Enter URLs:
                </label>
                <textarea
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="urls"
                    name="urls"
                    value={urls}
                    rows={10}
                    onChange={handleUrlsChange}
                />
            </div>

            <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2" htmlFor="count">
                    Number of times to open:
                </label>
                <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="count"
                    name="count"
                    type="number"
                    min="1"
                    value={count}
                    onChange={handleCountChange}
                />
            </div>

            <div className="flex items-center justify-center">
                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-4 rounded focus:outline-none focus:shadow-outline"
                    onClick={openUrls}
                >
                    Open URLs
                </button>
            </div>
        </div>
    );
};

export default UrlOpener;
